<div class="grid">
    <div class="image-container" *ngFor="let item of items; let i = index" [ngClass]="{'stacked': isImageStackFunction(item)}">
        <img [src]="imageUrlFunction(item)" [alt]="imageNameFunction(item)" (click)="handleItemClick(item, i)" class="clickable">
        <div *ngIf="showImageNameInGrid" class="wt-small-title">{{imageNameFunction(item)}}</div>
    </div>
</div>
